export default __webpack_public_path__ + "img/ef80c149a0c40e185ecf5dce7018f75b.png";